<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @change="v=>$emit('change',v)"
    :multiple="multiple"
    placeholder="请选择商品分类"
    idKey="IdChain"
    labelKey="ClassName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import api from "@/api/ba/class";
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  components: { commonSelect },
  data() {
    return { api, data: [] };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.list({ClassType: 6}).then((res) => {
          
          this.data = res.Data;
          resolve({ Data: res.Data });
        });
      });
    },
    getData() {
      return this.data;
    },
  },
};
</script>

